// extracted by mini-css-extract-plugin
module.exports = {"mainBlock":"mainContent_mainBlock__2Sf8v"};